<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ActiveForm v-if="active" :active="active" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ActiveForm from '@/components/settings/stock-registers/active/ActiveForm.vue'

  export default {
    name: 'Active',
    components: {
      PageTitle,
      PageRowWrapper,
      ActiveForm
    },
    computed: {
      ...mapState({
        active: state => state.active.activeById
      })
    },
    methods: {
      ...mapActions('active', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
